/** Seeded Gaussian noise so that noisy experiments replay identically. */
export class SeededNormal {
  private state: number;
  private spare: number | null = null;

  constructor(seed: number) {
    this.state = seed >>> 0 || 1;
  }

  /** mulberry32 uniform in (0, 1). */
  private uniform(): number {
    this.state = (this.state + 0x6d2b79f5) >>> 0;
    let t = this.state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    const u = ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    return u === 0 ? Number.MIN_VALUE : u;
  }

  /** Standard normal via Box–Muller. */
  next(): number {
    if (this.spare !== null) {
      const s = this.spare;
      this.spare = null;
      return s;
    }
    const u1 = this.uniform();
    const u2 = this.uniform();
    const mag = Math.sqrt(-2 * Math.log(u1));
    this.spare = mag * Math.sin(2 * Math.PI * u2);
    return mag * Math.cos(2 * Math.PI * u2);
  }
}
